import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';
import Cell from './cell';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

export default function Row({
  cellOverrides, lead, columns, renderLeadOptions, selectableLeadRowProps
}) {
  const anonymousLead = (children) => {
    const tooltipContent = (
      <Tooltip id="anonymous-lead-tooltip">
        <span>This lead has chosen to act on their privacy rights and delete their information</span>
      </Tooltip>
    );

    return (
      <OverlayTrigger key={lead.displayName} overlay={tooltipContent} placement="top">
        {children}
      </OverlayTrigger>
    );
  };

  const renderedColumns = columns.map((columnName) => {
    let cellContent;

    if (cellOverrides && cellOverrides[columnName]) {
      const OverrideComponent = cellOverrides[columnName];
      cellContent = <td key={columnName}><OverrideComponent lead={lead} /></td>;
    } else {
      cellContent = <Cell columnName={columnName} key={columnName} lead={lead} />;
    }

    if (columnName === 'displayName' && lead.leadData.name === 'Anonymous') {
      return anonymousLead(cellContent);
    }

    return cellContent;
  });

  const blockedRowClass = lead.approvalStatus === 'blocked' ? 'blocked-row' : '';

  return (
    <SelectableRow
      {...selectableLeadRowProps(lead)}
      className={blockedRowClass}
    >
      {renderedColumns}
      <td className={'text-center'}>{renderLeadOptions(lead)}</td>
    </SelectableRow>
  );
}

Row.propTypes = {
  cellOverrides: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  lead: PropTypes.object.isRequired,
  renderLeadOptions: PropTypes.func.isRequired,
  selectableLeadRowProps: PropTypes.func.isRequired
};
